"use client";

import { c as _c } from "react/compiler-runtime";
import { trackEmailComposerAction } from "../../analytics";
import { useEmailComposer } from "../../context";
import { useEditorState } from "@tiptap/react";
import { Button } from "@/components/ui";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown";
import { cx } from "@/lib/tailwind-utils";
const FONT_SIZES = [{
  label: "6",
  value: "6px"
}, {
  label: "8",
  value: "8px"
}, {
  label: "10",
  value: "10px"
}, {
  label: "12",
  value: "12px"
}, {
  label: "14",
  value: "14px"
}, {
  label: "16",
  value: "16px"
}, {
  label: "18",
  value: "18px"
}, {
  label: "22",
  value: "22px"
}, {
  label: "28",
  value: "28px"
}, {
  label: "36",
  value: "36px"
}] as const;
export function FontSizeSelect() {
  const $ = _c(14);
  const {
    editor
  } = useEmailComposer();
  let t0;
  if ($[0] !== editor) {
    t0 = {
      editor,
      selector: _temp
    };
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentSize = useEditorState(t0);
  let t1;
  if ($[2] !== currentSize) {
    t1 = FONT_SIZES.find(s => s.value === currentSize)?.label ?? parseInt(currentSize ?? "14") + "";
    $[2] = currentSize;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const currentLabel = t1;
  let t2;
  if ($[4] !== currentLabel) {
    t2 = <DropdownMenuTrigger asChild={true}><Button type="button" variant="ghost" size="icon-sm" tooltip="Font size" className="text-caption tabular-nums">{currentLabel}</Button></DropdownMenuTrigger>;
    $[4] = currentLabel;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== currentSize || $[7] !== editor) {
    t3 = FONT_SIZES.map(s_0 => <DropdownMenuItem key={s_0.value} className={cx("text-caption tabular-nums px-4", s_0.value === currentSize ? "bg-primary/10 text-foreground" : "text-foreground hover:bg-hover")} onMouseDown={_temp3} onClick={() => {
      if (!editor) {
        return;
      }
      editor.chain().focus().setFontSize(s_0.value).run();
      trackEmailComposerAction("font_size_changed", "toolbar", {
        size: s_0.label
      });
    }}>{s_0.label}</DropdownMenuItem>);
    $[6] = currentSize;
    $[7] = editor;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <DropdownMenuContent align="center" sideOffset={6} className="min-w-fit" onCloseAutoFocus={_temp2}>{t3}</DropdownMenuContent>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <DropdownMenu modal={false}>{t2}{t4}</DropdownMenu>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp3(e_0) {
  return e_0.preventDefault();
}
function _temp2(e) {
  return e.preventDefault();
}
function _temp(ctx) {
  if (!ctx.editor) {
    return "14px";
  }
  const markSize = ctx.editor.getAttributes("textStyle").fontSize as string;
  if (markSize) {
    return markSize;
  }
  if (ctx.editor.isActive("emailHeading", {
    level: 1
  })) {
    return "28px";
  }
  if (ctx.editor.isActive("emailHeading", {
    level: 2
  })) {
    return "22px";
  }
  if (ctx.editor.isActive("emailHeading", {
    level: 3
  })) {
    return "18px";
  }
  return "14px";
}